import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { dispatch } from '../../../store';
import { get, post, put } from '../../../../inteceptor';

const initialState = {
  roles: [],
  selectedRole: null,
  mutation: {},
  error: null,
};

const slice = createSlice({
  name: 'userRoles',
  initialState,
  reducers: {
    setRoles(state, action) {
      state.roles = action.payload || [];
    },
    setSelectedRole(state, action) {
      state.selectedRole = action.payload || null;
    },
    setMutation(state, action) {
      state.mutation = { data: action.payload?.data, time: moment.now().toString() };
      state.error = null;
    },
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },
    clearUserRoleState(state) {
      state.roles = [];
      state.selectedRole = null;
      state.mutation = {};
      state.error = null;
    },
  },
});

export default slice.reducer;

export const { clearUserRoleState } = slice.actions;

export function getUserRoles(params = {}) {
  return async () => {
    try {
      const response = await get('userRoles', params);
      if (response.status) dispatch(slice.actions.setRoles(response.data));
      else dispatch(slice.actions.hasError(response.message));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || error));
      return null;
    }
  };
}

export function getUserRoleById(roleId) {
  return async () => {
    try {
      const response = await get(`userRoles/${roleId}`);
      if (response.status) dispatch(slice.actions.setSelectedRole(response.data));
      else dispatch(slice.actions.hasError(response.message));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || error));
      return null;
    }
  };
}

export function createUserRole(body) {
  return async () => {
    try {
      const response = await post('userRoles', body);
      if (response.status) dispatch(slice.actions.setMutation(response));
      else dispatch(slice.actions.hasError(response.message));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.code || error?.message || error));
      return null;
    }
  };
}

export function updateUserRole(roleId, body) {
  return async () => {
    try {
      const response = await put(`userRoles/${roleId}`, body);
      if (response.status) dispatch(slice.actions.setMutation(response));
      else dispatch(slice.actions.hasError(response.message));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.code || error?.message || error));
      return null;
    }
  };
}

export function archiveUserRole(roleId) {
  return async () => {
    try {
      const response = await put(`userRoles/${roleId}/archive`);
      if (response.status) dispatch(slice.actions.setMutation(response));
      else dispatch(slice.actions.hasError(response.message));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.code || error?.message || error));
      return null;
    }
  };
}

export function assignUserRole(body) {
  return async () => {
    try {
      const response = await put('accessControl/role', body);
      if (response.status) dispatch(slice.actions.setMutation(response));
      else dispatch(slice.actions.hasError(response.message));
      return response;
    } catch (error) {
      dispatch(slice.actions.hasError(error?.code || error?.message || error));
      return null;
    }
  };
}
